import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex flex-1 flex-col items-center justify-center px-4 py-24 text-center">
        <span className="font-heading text-7xl font-black text-primary-300 md:text-9xl">404</span>
        <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">这个页面走丢了</h1>
        <p className="mt-3 text-sm text-foreground-600">
          你访问的地址可能已经被调整或不存在：
          <span className="ml-1 text-foreground-400">{location.pathname}</span>
        </p>
        <div className="mt-8 flex flex-col gap-4 sm:flex-row">
          <Link
            to="/"
            className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-5-line"></i>返回首页
          </Link>
          <Link
            to="/topics"
            className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            <i className="ri-book-shelf-line"></i>浏览话题库
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}